/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowMerge = createReactComponent("outline", "arrow-merge", "IconArrowMerge", [["path", { "d": "M8 7l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394", "key": "svg-1" }], ["path", { "d": "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394", "key": "svg-2" }]]);

export { IconArrowMerge as default };
//# sourceMappingURL=IconArrowMerge.mjs.map
